import BodyType from 'owa-service/lib/contract/BodyType';
import { HtmlSanitizer } from 'roosterjs-html-sanitizer';

export default function convertInlineCssForHtml(source: string, bodyType: BodyType): string {
    return bodyType == 'HTML' ? HtmlSanitizer.convertInlineCss(source) : source;
}
